class ForgotpasswordForm {
  constructor() {
    this.emailAddress = null;
    this.error = null;
    this.success = null;
  }

  toPayload() {
    return {
      requestResetPassword: {
        email: this.emailAddress,
      },
      origin: origin,
    };
  }
};

export default ForgotpasswordForm;



// WEBPACK FOOTER //
// ./client/app/pages/forgotpassword/model/form.model.js